import styled from "styled-components";
import {Form} from "react-bootstrap";

type CardContainerProps = {
    cheked: boolean
}
export const CardContainer = styled.article<CardContainerProps>`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  //position: relative;
  //z-index: 0;

  border: ${({cheked}) => cheked ? " 1px dashed blue" :  "1px solid black" };
  border-radius: 15px;
  padding: 10px;
  
  &:hover {
    background: rgba(246, 238, 229, 0.5);
  }

  @media (max-width: 760px) {
    &:hover {
      background: transparent;
    }
    -moz-user-select: none; /* Firefox */
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE */
    user-select: none
  }
  
  
`
export const CardContext = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 10px;
`



export type CardContextImgProps = {
    image: string;
};

export const CardContextImg = styled.div<CardContextImgProps>`
  display: flex;
  max-height: 60px;
  background-image: url(${({image}) => image});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 150px;
  height: 150px;
  justify-content: flex-end;
  
`

export const CardImg = styled.img`
  object-fit: scale-down;
  width: 100%;
  height: auto;
`

export const CardText = styled.p`
  justify-self: center;
  margin: 0;
  font-size: 12px;
  align-self: center;
  align-items: center;
  text-align: center;
`

export const FormCheck=styled(Form.Check)`
  //  position: absolute;
  //top: 0%;
  //left: 50%;
`
